var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{style:(_vm.data.labels.length <= 10 ? `height: ${_vm.data.labels.length * 35}px;` : `height: ${_vm.data.labels.length * 25}px;`)},[_c('canvas',{attrs:{"id":_vm.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }